export enum TextFieldSizes {
  REGULAR = 'regular',
  HUGE = 'huge',
}
